export default __webpack_public_path__ + "static/media/overview.93d8f00e.svg";